var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip billing-history-status",attrs:{"color":_vm.chipColor(_vm.status)}},[_c('div',{staticClass:"billing-status-icon"},[_c('feather-icon',{attrs:{"icon":_vm.chipIcon(_vm.status),"svgClasses":"h-5 w-5 ml-1"}})],1),_c('div',{staticClass:"billing-status-text"},[_vm._v(" "+_vm._s(_vm.chipStatus)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }